<template>
    <div role="list">
        <slot/>
    </div>
</template>

<script>
export default {
        name: "SettingsList",
    }
</script>